import { MembershipStatus } from '@/types/api/membership';

// prettier-ignore
export function membershipStatusLabel(status: MembershipStatus): string {
  switch (status) {
    case MembershipStatus.Active:   return 'Aktiv';
    case MembershipStatus.Resigned: return 'Lämnat';
    case MembershipStatus.Revoked:  return 'Borttagen';
    default:                        return "Okänd"
  }
}

// prettier-ignore
export function membershipStatusBadge(status: MembershipStatus): string {
  switch (status) {
    case MembershipStatus.Active:   return 'bg-green-500/20 text-green-700';
    case MembershipStatus.Resigned: return 'bg-gray-500/20 text-gray-700';
    case MembershipStatus.Revoked:  return 'bg-red-500/20 text-red-700';
    default:                        return 'bg-gray-500/20 text-gray-700';
  }
}
